import { render, staticRenderFns } from "./AccountStatementCard.vue?vue&type=template&id=53b5c94a&scoped=true"
import script from "./AccountStatementCard.vue?vue&type=script&lang=js"
export * from "./AccountStatementCard.vue?vue&type=script&lang=js"
import style0 from "./AccountStatementCard.vue?vue&type=style&index=0&id=53b5c94a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b5c94a",
  null
  
)

export default component.exports